export default {
    // API_BASE_URL: "http://localhost:5001/graphql",
    API_BASE_URL: "https://api-dev.dh-thailand.com/graphql",
    FRONT_ORDER_URL: "https://order-dev.dh-thailand.com/",
    FRONT_BOOKING_URL: "https://booking-dev.dh-thailand.com/",
    WORK_INFINITY_OAUTH:
        "https://staff-dev.workinfinityx.com/oauth?client_id=633ceb8e49da3d5bb4c3928f",
};
